































import { Component, Inject, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IContractProduct } from "@/models/contracts";
import { IInvoiceProvider } from "@/models/providers/invoice";
import CProdMixin from "@/mixins/cProdMixin";
import Context from "@/mixins/context";
import { AdminRoutes } from "@/data/enums/router";

@Component
export default class InvoiceProductsInactiveMsg extends Mixins(
  Context,
  CProdMixin
) {
  // Props
  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;

  // Computed
  public get $invoiceData() {
    return this.$invoiceProvider();
  }

  public get inactiveCProdsArray() {
    return this.$_.toArray(this.$invoiceData.inactiveCProds);
  }

  // Methods
  public openReactivationModal(contractProduct: IContractProduct) {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/openReactivationModal`,
      {
        props: {
          contractProductId: contractProduct.id,
          contractId: contractProduct.contract_id,
          openInvoicePreviewModal: false,
          title: this.$t(`_.reactivate_object`, {
            object: this.getProductName(contractProduct)
          })
        },
        events: {
          "contract-product-updated": () => {
            this.$router.push({
              name: AdminRoutes.CONTRACT_PRODUCT_OVERVIEW,
              params: {
                clientId: this.$invoiceData.invoice.client_id,
                contractId: contractProduct.contract_id,
                productId: contractProduct.id
              }
            });
          }
        }
      }
    );
  }
}
